import i18next from 'i18next';
import { onMounted, onUnmounted } from 'vue';

export const useLanguageChanged = (callback: (newLang: string, oldLang: string) => void) => {
    let selectedLang = i18next.language;

    const langChanged = (newlang: string) => {
        callback(newlang, selectedLang);
        selectedLang = newlang;
    };

    onMounted(() => i18next.on('languageChanged', langChanged));
    onUnmounted(() => i18next.off('languageChanged', langChanged));
};
